import styled from "styled-components";
import {ITEM_WRAPPER_BOX} from "../../css-constants";
import { Image } from "../../../../../raw-components/image/image";

export const LiveCasinoGridItemThumbnailImageDefaultBox = styled(Image)`
  width: 100%;
  transition: transform 0.25s ease;
 .${ITEM_WRAPPER_BOX}:hover &{
     transform: scale(1.2);
  }
`;